import api from "@/api/api-v2-config";

export async function getFeedbackIdAxios(id) {    
    return await api.get("selfservices/getcustomerfeedback?Id="+ id);
}